const rightSidebarDrawers = {
    summary: "summary"
  };
  
  export default rightSidebarDrawers;
  